"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudyReportEssential = exports.StudyReport = exports.StudyReportStatus = exports.StudyReportType = void 0;
var StudyReportType;
(function (StudyReportType) {
    StudyReportType["Sae"] = "SAE";
    StudyReportType["Ae"] = "AE";
    StudyReportType["Pregnancy"] = "PREGNANCY";
})(StudyReportType = exports.StudyReportType || (exports.StudyReportType = {}));
var StudyReportStatus;
(function (StudyReportStatus) {
    StudyReportStatus["Initial"] = "INITIAL";
    StudyReportStatus["InitialCapture"] = "INITIAL-CAPTURE";
    StudyReportStatus["InitialSubmission"] = "INITIAL-SUBMISSION";
    StudyReportStatus["FollowUp"] = "FOLLOW-UP";
    StudyReportStatus["FollowUpCapture"] = "FOLLOW-UP-CAPTURE";
    StudyReportStatus["FollowUpSubmission"] = "FOLLOW-UP-SUBMISSION";
    StudyReportStatus["Deleted"] = "DELETED";
    StudyReportStatus["Cancelled"] = "CANCELLED";
    StudyReportStatus["Recovered"] = "RECOVERED";
})(StudyReportStatus = exports.StudyReportStatus || (exports.StudyReportStatus = {}));
class StudyReport {
}
exports.StudyReport = StudyReport;
class StudyReportEssential {
}
exports.StudyReportEssential = StudyReportEssential;
//# sourceMappingURL=studyReport.js.map